import { render, staticRenderFns } from "./AnggotaDetails.vue?vue&type=template&id=6bbfcc4c&"
import script from "./AnggotaDetails.vue?vue&type=script&lang=js&"
export * from "./AnggotaDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnggotaDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports